import React from 'react';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { Dispatch } from 'redux';
import { AppState, Menu } from 'acscp/store';
import { SetOpenMenu } from 'acscp/actions';
import { SideScreen } from 'acscp/components/common/sideScreen';
import style from 'acscp/components/common/sideScreen.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { userCanAccessCharters } from 'acscp/store/helpers/authHelper';
import { AccountLinks } from '../accountLinks/accountLinks';
import { AccountLinkForm } from '../accountLinks/accountLinkForm';

interface AccountPreferencesStateProps {
    isOpen: boolean;
    canAccessCharters: boolean;
}

interface AccountPreferencesDispatchProps {
    closeMenu: () => void;
}

export class AccountPreferencesPresentational extends PresentationComponentBase<{},
    AccountPreferencesStateProps, AccountPreferencesDispatchProps, {}> {

    render(): JSX.Element | null {
        const { isOpen, closeMenu, canAccessCharters } = this.props;

        if (!isOpen || !canAccessCharters) {
            return null;
        }
        return (
            <SideScreen>
                <div className={style.BlueHeader}>
                    <FormattedMessage
                        id={'components.accountPreferences.accountPreferences'}
                        defaultMessage={'Account Preferences'}
                    />
                    <a href="javascript:;" id="Exit" onClick={closeMenu} aria-label="Close">
                        <CrossIcon />
                    </a>
                </div>
                <div className={classNames(style.MediumItem, style.WithBorder)}>
                    <FormattedMessage
                            id={'components.accountPreferences.linkMyAccount'}
                            defaultMessage={'Link My Account'}
                    />
                </div>
                <AccountLinkForm />
                <div className={style.SmallItem}>
                    <FormattedMessage
                        id={'components.accountPreferences.linkedAccounts'}
                        defaultMessage={'Linked Accounts'}
                    />
                </div>
                <AccountLinks/>
            </SideScreen>
        );
    }
}

function mapStateToProps(state: AppState): AccountPreferencesStateProps {
    return {
        isOpen: state.menu.currentlyOpenMenu === Menu.AccountPreferences,
        canAccessCharters: userCanAccessCharters(state.auth)
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): AccountPreferencesDispatchProps {
    return {
        closeMenu: () => dispatch(new SetOpenMenu(undefined)),
    };
}

export const AccountPreferences = connectWithRequests(mapStateToProps, mapDispatchToProps)
    (AccountPreferencesPresentational);
